/**
 * Opciones de tipo de contacto y tipo de notificación.
 * Deben estar sincronizadas con el backend
 * (client-contacts/schema/client-contact.schema.ts).
 */
export const TIPO_CONTACTO_OPTIONS = [
  { value: 'Principal', label: 'Principal' },
  { value: 'Comercial', label: 'Comercial' },
  { value: 'Facturación', label: 'Facturación' },
  { value: 'Operativo', label: 'Operativo' },
  { value: 'Técnico', label: 'Técnico' },
  { value: 'Otro', label: 'Otro' },
];

export const TIPO_CONTACTO_BADGE = {
  Principal: 'bg-purple-100 text-purple-800',
  Comercial: 'bg-blue-100 text-blue-800',
  Facturación: 'bg-amber-100 text-amber-800',
  Operativo: 'bg-emerald-100 text-emerald-800',
  Técnico: 'bg-cyan-100 text-cyan-800',
  Otro: 'bg-slate-100 text-slate-800',
};

export const TIPO_NOTIFICACION_OPTIONS = [
  { value: 'Embarque', label: 'Embarque', description: 'Creación y avance de embarques' },
  { value: 'Documento', label: 'Documento', description: 'Recepción o carga de documentos' },
  { value: 'Factura', label: 'Factura', description: 'Emisión de facturas' },
  { value: 'Estado de cuenta', label: 'Estado de cuenta', description: 'Envío de estado de cuenta' },
  { value: 'Recordatorio', label: 'Recordatorio', description: 'Recordatorios de pago o vencimientos' },
  { value: 'Todos', label: 'Todos', description: 'Recibe todas las notificaciones' },
];

export const ESTADO_OPTIONS = [
  { value: 'Activo', label: 'Activo' },
  { value: 'Inactivo', label: 'Inactivo' },
];
